import { T as TransifexT } from '@transifex/react';
import { t as TransifexTFunction } from '@transifex/native';
import type { TransifexTProps } from './types';
import type { ITranslateParams } from '@transifex/native';
/**
 * Transifex translation component.
 *
 * @param {TransifexTProps} props - Translation props.
 * @param {boolean} [props.noWrap=false] - Whether to wrap the content in a span.
 * @param {string} props._str - The string to translate.
 * @returns {React.ReactNode} Translated content.
 */
export const T = ({ noWrap = false, ...props }: TransifexTProps) => {
  const content = <TransifexT {...props} />;

  return noWrap ? content : <span>{content}</span>;
};

export const t = (str: string, params?: ITranslateParams) => {
  return TransifexTFunction(str, params);
};
